<!--begin::Head-->
<div class="kt-login__head">
    <span class="kt-login__signup-label">Henüz bir hesabınız yok mu?</span>&nbsp;&nbsp;
    <a href="javascript:;" routerLink="/auth/register" class="kt-link kt-login__signup-link">{{
        'AUTH.GENERAL.SIGNUP_BUTTON' | translate
    }}</a>
</div>
<!--end::Head-->

<!--begin::Body-->
<div class="kt-login__body">
    <!--begin::Signin-->
    <div class="kt-login__form">
        <!-- <kt-auth-notice></kt-auth-notice> -->

        <div class="card shadow">
            <h4 class="align-middle text-center my-3">Kullanıcı Girişi</h4>

            <div class="kt-login__divider" style="margin: 0 !important;">
                <div class="kt-divider">
                    <span></span>
                </div>
            </div>
            <form class="card-body" [formGroup]="loginForm" (ngSubmit)="submit()">
                <div class="form-group">
                    <label for="userName">E-Posta / KimlikNo</label>
                    <input id="userName"
                           class="form-control"
                           type="text"
                           placeholder="E-Posta / KimlikNo"
                           aria-placeholder="E-Posta / Kimlik No"
                           formControlName="userName"
                           autocomplete="off"
                           [ngClass]="{
                            'is-invalid': loginForm.touched && loginForm.controls.userName.errors,
                            'is-valid': loginForm.touched && !loginForm.controls.userName.errors
                        }" />
                </div>
                <div class="form-group">
                    <label for="password">Parola</label>
                    <input id="password"
                           class="form-control"
                           type="password"
                           placeholder="Parola"
                           aria-placeholder="Parola"
                           formControlName="password"
                           autocomplete="off"
                           [ngClass]="{
                            'is-invalid': loginForm.touched && loginForm.controls.password.errors,
                            'is-valid': loginForm.touched && !loginForm.controls.password.errors
                        }" />
                </div>
                <div class="text-right">
                    <a class="btn btn-default mr-1" routerLink="/auth/forgot-password">
                        <i class="fa fa-fish"></i>
                        {{ 'AUTH.GENERAL.FORGOT_BUTTON' | translate }}
                    </a>
                    <button type="submit" class="btn btn-primary">
                        <i class="fa fa-sign-in-alt"></i> {{ 'AUTH.LOGIN.BUTTON' | translate }}
                    </button>
                </div>
            </form>
        </div>
        <!--end::Form-->
        <!--begin::Divider-->
        <!-- <div class="kt-login__divider">
        <div class="kt-divider">
            <span></span>
        </div>
    </div> -->
        <!--end::Divider-->
        <!--begin::Options-->
        <!-- <div class="kt-login__options">
        <a href="https://www.facebook.com/keenthemes/" target="_blank" class="btn btn-primary kt-btn">
            <i class="fab fa-facebook-f"></i>
            Facebook
        </a>

        <a href="https://twitter.com/keenthemes/" target="_blank" class="btn btn-info kt-btn">
            <i class="fab fa-twitter"></i>
            Twitter
        </a>

        <a href="javascript:;" class="btn btn-danger kt-btn">
            <i class="fab fa-google"></i>
            Google
        </a>
    </div> -->
        <!--end::Options-->
        <div style="text-align:center; padding-top:15px;"><span>Otomatik mail gönderimi ile alakalı sorun giderilmiştir. <b>Tekrar deneyebilirsiniz.</b></span></div>
    </div>
    <!--end::Signin-->
    
</div>
<!--end::Body-->
